__turbopack_context__.v({
  "bg": "FlyoutWrapper-module__NPQgrq__bg",
  "bgHiddenOnMobile": "FlyoutWrapper-module__NPQgrq__bgHiddenOnMobile",
  "content": "FlyoutWrapper-module__NPQgrq__content",
  "contentCenter": "FlyoutWrapper-module__NPQgrq__contentCenter",
  "contentLeft": "FlyoutWrapper-module__NPQgrq__contentLeft",
  "contentRight": "FlyoutWrapper-module__NPQgrq__contentRight",
  "paper": "FlyoutWrapper-module__NPQgrq__paper",
  "paperFull": "FlyoutWrapper-module__NPQgrq__paperFull",
  "root": "FlyoutWrapper-module__NPQgrq__root",
});
